import React, { useState } from 'react';
import SkillTreeRPG from '../components/SkillTreeRPG';
import AchievementsBadges from '../components/AchievementsBadges';
import CodeBattle from '../components/CodeBattle';
import CodeSmellDetector from '../components/CodeSmellDetector';
import GhostCoding from '../components/GhostCoding';

const TestFeatures = () => {
  const [showSkillTree, setShowSkillTree] = useState(false);
  const [showAchievements, setShowAchievements] = useState(false);
  const [showBattle, setShowBattle] = useState(false);
  const [showGhostCoding, setShowGhostCoding] = useState(false);
  const [code, setCode] = useState('public class Test {\n  public void example() {\n    for(int i=0; i<100; i++) {\n      for(int j=0; j<100; j++) {\n        System.out.println(12345);\n      }\n    }\n  }\n}');

  return (
    <div style={{ 
      padding: '40px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
        marginBottom: '30px'
      }}>
        <h1 style={{ 
          fontSize: '42px', 
          marginBottom: '10px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: '700'
        }}>
          🧪 Test Innovative Features
        </h1>
        <p style={{ fontSize: '18px', color: '#666', marginBottom: '30px' }}>
          Click any button below to test the revolutionary features!
        </p>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '20px'
        }}>
          <button 
            onClick={() => setShowSkillTree(true)}
            style={{
              padding: '40px 30px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: '600',
              boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
              transition: 'all 0.3s',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 15px 40px rgba(102, 126, 234, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 30px rgba(102, 126, 234, 0.3)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>🎮</div>
            <div>RPG Skill Tree</div>
            <div style={{ fontSize: '12px', opacity: 0.9, marginTop: '8px' }}>
              Levels, XP & Skills
            </div>
          </button>

          <button 
            onClick={() => setShowAchievements(true)}
            style={{
              padding: '40px 30px',
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: '600',
              boxShadow: '0 10px 30px rgba(240, 147, 251, 0.3)',
              transition: 'all 0.3s',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 15px 40px rgba(240, 147, 251, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 30px rgba(240, 147, 251, 0.3)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>🏆</div>
            <div>Achievements</div>
            <div style={{ fontSize: '12px', opacity: 0.9, marginTop: '8px' }}>
              Badges & Rewards
            </div>
          </button>

          <button 
            onClick={() => setShowBattle(true)}
            style={{
              padding: '40px 30px',
              background: 'linear-gradient(135deg, #e94560 0%, #f48fb1 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: '600',
              boxShadow: '0 10px 30px rgba(233, 69, 96, 0.3)',
              transition: 'all 0.3s',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 15px 40px rgba(233, 69, 96, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 30px rgba(233, 69, 96, 0.3)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>⚔️</div>
            <div>Code Battle</div>
            <div style={{ fontSize: '12px', opacity: 0.9, marginTop: '8px' }}>
              Compete Live
            </div>
          </button>

          <button 
            onClick={() => setShowGhostCoding(true)}
            style={{
              padding: '40px 30px',
              background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: '600',
              boxShadow: '0 10px 30px rgba(79, 172, 254, 0.3)',
              transition: 'all 0.3s',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 15px 40px rgba(79, 172, 254, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 30px rgba(79, 172, 254, 0.3)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>👻</div>
            <div>Ghost Coding</div>
            <div style={{ fontSize: '12px', opacity: 0.9, marginTop: '8px' }}>
              Solution Recordings
            </div>
          </button>
        </div>
      </div>

      {/* Code Smell Detector Demo */}
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '30px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ 
          fontSize: '28px', 
          marginBottom: '15px',
          color: '#333'
        }}>
          ✨ Code Smell Detector (Real-time)
        </h2>
        <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
          Type or edit code below and wait 2 seconds to see real-time analysis!
        </p>
        
        <textarea
          value={code}
          onChange={(e) => setCode(e.target.value)}
          style={{
            width: '100%',
            minHeight: '200px',
            padding: '15px',
            fontSize: '14px',
            fontFamily: 'Consolas, Monaco, "Courier New", monospace',
            border: '2px solid #e0e0e0',
            borderRadius: '10px',
            marginBottom: '20px',
            background: '#f8f9fa',
            resize: 'vertical'
          }}
          placeholder="Type some code here..."
        />
        
        <CodeSmellDetector 
          code={code} 
          language="java"
          onAnalysisComplete={(analysis) => {
            console.log('Analysis:', analysis);
          }}
        />

        <div style={{
          marginTop: '20px',
          padding: '15px',
          background: '#f0f8ff',
          borderRadius: '10px',
          border: '2px solid #4facfe'
        }}>
          <strong>💡 Try this:</strong>
          <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
            <li>Add nested loops → See smell clouds appear</li>
            <li>Write clean code → See sparkles</li>
            <li>Add magic numbers like 12345 → Get warnings</li>
            <li>Make methods too long → Get suggestions</li>
          </ul>
        </div>
      </div>

      {/* Feature Info */}
      <div style={{
        marginTop: '30px',
        padding: '30px',
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)'
      }}>
        <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#333' }}>
          📚 What You Can Test
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
          <div>
            <h4 style={{ color: '#667eea', fontSize: '18px', marginBottom: '10px' }}>🎮 RPG System</h4>
            <ul style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
              <li>View your level and XP</li>
              <li>See character progression</li>
              <li>Explore skill trees</li>
              <li>Check your stats</li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#f5576c', fontSize: '18px', marginBottom: '10px' }}>🏆 Achievements</h4>
            <ul style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
              <li>View unlocked badges</li>
              <li>See rarity levels</li>
              <li>Filter by category</li>
              <li>Track progress</li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#e94560', fontSize: '18px', marginBottom: '10px' }}>⚔️ Battles</h4>
            <ul style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
              <li>Create competitions</li>
              <li>Browse active battles</li>
              <li>Join by code</li>
              <li>See leaderboards</li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#00f2fe', fontSize: '18px', marginBottom: '10px' }}>👻 Ghost Coding</h4>
            <ul style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
              <li>Watch solution recordings</li>
              <li>Playback at different speeds</li>
              <li>Learn coding patterns</li>
              <li>Like top solutions</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Modals */}
      <SkillTreeRPG 
        isOpen={showSkillTree} 
        onClose={() => setShowSkillTree(false)} 
      />
      
      <AchievementsBadges 
        isOpen={showAchievements} 
        onClose={() => setShowAchievements(false)} 
      />
      
      <CodeBattle 
        isOpen={showBattle} 
        onClose={() => setShowBattle(false)} 
      />
      
      <GhostCoding 
        questionId={1} 
        isOpen={showGhostCoding} 
        onClose={() => setShowGhostCoding(false)} 
      />
    </div>
  );
};

export default TestFeatures;


